
export const API_BASE_URL = "https://digitalnow.molecularconnections.com/digital_now_services/croplife_api";
// export const API_BASE_URL = "http://localhost:7075/croplife_api";

export const LOGIN_NEEDED = true;

//export const API_BASE_URL = "http://178.79.188.46:7075/croplife_api";
// export const API_BASE_URL ="https://mc-apps.molecularconnections.com/croplife_api_test";

//Test Link
// export const API_BASE_URL ="http://mc-apps.molecularconnections.com/croplife_api";

//export const API_BASE_URL = "https://digitalnow-test.molecularconnections.com/digital_now_services_test/croplife_api_test";


